<template>
  <div class="w-full relative">
    <a
      class="flex"
      href="https://www.youtube.com/watch?v=TvHaoJwXx0Q"
      data-lity
    >
      <img
        class="absolute md:w-3/12 xs:w-3/12 m-auto inset-x-0 xs:top-3/10"
        :src="`${imgPath}/Section01/animation-movie.png`"
      />
    </a>
    <img class="w-full" :src="`${imgPath}/Section01/top-image-mobile.jpg`" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
};
</script>

<style></style>
